import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import { OpalApi } from '../../schema'

type CreateBulkUpdateV3 = OpalApi<'CreateBulkOperationV3', 201>

export const createBulkUpdateOperation: CreateBulkUpdateV3 = async (
  args = {}
) => {
  const url = new URL(`/v3/bulk_operations`, window.location.origin)

  url.search = queryString(args.params?.query)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
